import { Component, OnInit } from '@angular/core';
import { BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-numbered-list',
    templateUrl: './block-numbered-list.component.html',
})

export class BlockNumberedListComponent extends BlockAbstractComponent implements OnInit {

}
